<template>
    <div class="legal-person-step1" v-loading="pageLoading">
        <el-form ref="formData" class="sr-from-single" label-width="150px" :model="formData">
            <el-form-item label="委托书模板">
                <TemplateDownload name="委托授权书模板.pdf" :url="templateUrl" tips="请务必使用模板，否则无法通过认证"></TemplateDownload>
            </el-form-item>
            <el-form-item prop="enTrustPhotoPath" :rules="[{ required: true, message: '请上传盖公章委托书' }]" label="盖公章委托书">
                <ImageUpload class="horizontal" :url.sync="formData.enTrustPhotoPath" accept="image/png,image/jpeg"
                    :size="10" fixedNumber="2:3" :btnText="{ add: '上传头像', update: '修改头像' }" :drag="false"
                    @onSuccess="handleImageSuccess">
                    <template slot="tips">
                        <b style="color: #000;">务必加盖公章</b><br />
                        提示：
                        <br />
                        1. 大小不超过10M
                        <br />
                        2. 仅支持 .png、.jpg、.jpeg
                    </template>
                </ImageUpload>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="previousStep()">上一步</el-button>
                <el-button type="primary" :loading="loading" @click="onSubmit">提交委托书</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import TemplateDownload from '@/components/TemplateDownload';
import { enterprisePowerAttorney, enterpriseTemplate, setEnterpriseStep } from '@/api/user';
export default {
    components: {
        ImageUpload,
        TemplateDownload,
    },
    data() {
        return {
            pageLoading: false,
            loading: false,
            templateUrl: '',
            formData: {
                enTrustPhotoPath: '', // 企业委托书
            },
        };
    },
    mounted() {
        this.initFrom();
        this.getTemplate();
    },
    methods: {
        async initFrom() {
            const { certifyInfo } = this.$store.getters;
            this.certifyInfo = certifyInfo;
        },
        async previousStep() {
            const flag = await this.$confirm(`返回后当前页面的信息将不会保存。`, '确定要返回操作吗？');
            if (flag === 'cancel') return;
            const respnose = await setEnterpriseStep(3);
            const { state, msg } = respnose.data;
            if (!state) return this.$message.error(msg || '返回上一步失败，请稍后尝试');
            this.$emit('updateStep');
        },
        // 获取委托书模版
        async getTemplate() {
            const respnose = await enterpriseTemplate();
            const { state, msg, result } = respnose.data;
            if (!state) return this.$message.error(msg || '委托书模版获取失败，请稍后尝试');
            this.templateUrl = result;
        },
        async onSubmit() {
            const valid = await this.$refs['formData'].validate();
            if (!valid) return;
            this.loading = true;
            const respnose = await enterprisePowerAttorney(this.formData.enTrustPhotoPath);
            const { state, msg } = respnose.data;
            this.loading = false;
            this.$emit('updateStep');
            if (!state) return this.$message.error(msg || '委托书验证失败，请稍后尝试');
        },
        handleImageSuccess(data) {
            const { url } = data;
            if (url) this.formData.enTrustPhotoPath = url;
        },
    },
};
</script>
<style lang="scss" scoped></style>
